import React from 'react'
import './EditYAxisBarCharts.scss'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import DoneIcon from '@material-ui/icons/Done'
import { withStyles } from '@material-ui/core/styles'
import ClearIcon from '@material-ui/icons/Clear'

const styles = {
  dialogPaper: {
    minHeight: '235px',
    minWidth: '730px'
  },
  root: {
    backgroundColor: '#eaeaea'
  }
}
export class EditYAxisBarCharts extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      min: props.yaxisConfig.min,
      max: props.yaxisConfig.max,
      interval: props.yaxisConfig.interval
    }
  }

  componentDidUpdate = prevProps => {
    if (prevProps.yaxisConfig !== this.props.yaxisConfig) {
      this.setState({
        ...this.props.yaxisConfig
      })
    }
  }

  handleSubmit = () => {
    const yaxisconfig = {
      action: true, // this for reset barchart y axis config
      pageTitle: this.props.pageTitle,
      yaxisConfig: {
        min: Number(this.state.min),
        max: Number(this.state.max),
        interval: Number(this.state.interval)
      }
    }
    this.props.handleYAxisSubmit(yaxisconfig)
  }

  handleCancel = () => {
    this.setState(
      {
        min: this.props.yaxisConfig.min,
        max: this.props.yaxisConfig.max,
        interval: this.props.yaxisConfig.interval
      },
      () => this.props.handleEditDialog()
    )
  }

  handleReset = () => {
    this.setState({
      min: this.props.yaxisConfig.min,
      max: this.props.yaxisConfig.max,
      interval: this.props.yaxisConfig.interval
    })
  }

  handleParametersChange = event => {
    const { name, value } = event.target
    if (value >= 0) {
      this.setState({
        [name]: value
      })
    }
  }

  render() {
    const { form, classes } = this.props
    const { min, max, interval } = this.state

    return (
      <Dialog
        data-testid="barchart_edit_dialog"
        classes={{ paper: classes.dialogPaper }}
        open={form}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <div className="barchart_Yedit_title">
            <div>PRICE RANGE-Y AXIS</div>
            <div>
              <ClearIcon
                data-testid="barchart_edit__actions_cancel"
                onClick={this.handleCancel}
              />
            </div>
          </div>
          <div className="barchart_Yedit">
            <TextField
              name="min"
              label="Min."
              id="barchart_edit_yaxis_min"
              inputProps={{ 'data-testid': 'barchart_edit_yaxis_min' }}
              value={min}
              variant="outlined"
              size="small"
              type="number"
              onChange={event => this.handleParametersChange(event)}
            />
            <TextField
              name="max"
              label="Max."
              id="barchart_edit_yaxis_max"
              inputProps={{ 'data-testid': 'barchart_edit_yaxis_max' }}
              value={max}
              variant="outlined"
              size="small"
              type="number"
              onChange={event => this.handleParametersChange(event)}
            />
            <TextField
              name="interval"
              label="Intervals"
              id="barchart_edit_yaxis_interval"
              inputProps={{ 'data-testid': 'barchart_edit_yaxis_interval' }}
              value={interval}
              variant="outlined"
              size="small"
              type="number"
              onChange={event => this.handleParametersChange(event)}
            />
          </div>
        </DialogContent>
        <DialogActions classes={{ root: classes.root }}>
          <div className="barchart_edit__actions">
            <div>
              <Button
                data-testid="barchart_edit__actions_reset"
                id="barchart_edit__actions_reset"
                onClick={this.handleReset}
                color="secondary"
              >
                Reset
              </Button>
              <Button
                data-testid="barchart_edit__actions_done"
                id="barchart_edit__actions_done"
                onClick={this.handleSubmit}
                color="secondary"
              >
                <DoneIcon />
                Done
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    )
  }
}

EditYAxisBarCharts.propTypes = {
  handleEditDialog: PropTypes.func,
  handleYAxisSubmit: PropTypes.func,
  pageTitle: PropTypes.string,
  yaxisConfig: PropTypes.object,
  chartData: PropTypes.object,
  classes: PropTypes.object,
  form: PropTypes.bool
}

export default withStyles(styles)(EditYAxisBarCharts)
